import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const other = i18n.language === 'ar' ? 'en' : 'ar';
  return (
    <button
      onClick={() => i18n.changeLanguage(other)}
      className="rounded-md border border-border bg-surface px-3 py-1 text-sm text-text-muted transition hover:border-border-strong hover:text-text"
    >
      {other === 'ar' ? 'عربي' : 'English'}
    </button>
  );
}
